import TickPicker from './tick-picker';
import './tick-picker.scss';

export default TickPicker;
